import { isPlatformServer } from '@angular/common';
import { Inject, Injectable, Optional, PLATFORM_ID } from '@angular/core';
import { TransferState } from '@angular/platform-browser';
import { SITE_CONFIG_KEY } from '../tokens/site-config-key.token';
// import * as moment from 'moment';
import * as moment from 'moment-timezone';
import { REQUEST, RESPONSE } from '@nguniversal/express-engine/tokens';

/** 日誌，只有 console 打印 */
@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  protected isServer: boolean;
  protected isSSRMode: boolean;

  constructor(
    @Inject(PLATFORM_ID) protected platformId: object,
    protected transferState: TransferState,
    @Optional() @Inject(REQUEST) protected request: Request,
    @Optional() @Inject(RESPONSE) protected response: Response,
  ) {
    this.isServer = isPlatformServer(this.platformId);
    this.isSSRMode = this.isServer || this.transferState.hasKey(SITE_CONFIG_KEY);
  }

  info(msg: string, ...optionalParams: any[]) {
    if (this.isSSRMode) {
      if (this.isServer) {
        global['nodeLogger']['info'](this.request, this.response, msg, ...optionalParams);
      } else {
        console.log(`${moment().tz("Asia/Taipei").format('YYYY/MM/DD HH:mm:ss.SSS')} [${'info'}] ${msg}`, ...optionalParams);
      }
    } else {
      console.log(msg, ...optionalParams);
    }
  }

  warn(msg: string, ...optionalParams: any[]) {
    if (this.isSSRMode) {
      if (this.isServer) {
        global['nodeLogger']['warn'](this.request, this.response, msg, ...optionalParams);
      } else {
        console.warn(`${moment().tz("Asia/Taipei").format('YYYY/MM/DD HH:mm:ss.SSS')} [${'warn'}] ${msg}`, ...optionalParams);
      }
    } else {
      console.warn(msg, ...optionalParams);
    }
  }

  error(msg: string, ...optionalParams: any[]) {
    if (this.isSSRMode) {
      if (this.isServer) {
        global['nodeLogger']['error'](this.request, this.response, msg, ...optionalParams);
      } else {
        console.error(`${moment().tz("Asia/Taipei").format('YYYY/MM/DD HH:mm:ss.SSS')} [${'error'}] ${msg}`, ...optionalParams);
      }
    } else {
      console.error(msg, ...optionalParams);
    }
  }
}
